module.exports = __webpack_public_path__ + "static/NotoSans-Regular.subset-e7201d996d1245fe9d26377e56e15cbb.woff2";